import React, { useEffect } from 'react';
import tw, { styled } from 'twin.macro';
import { useTranslation } from 'next-i18next';
import Lottie from 'lottie-react';

import useRestaurantOnboardingDataQuery from './use-restaurant-onboarding-data-query';
import robotAnimationData from './robot-animation.json';
import startIconAnimationData from './star-icon-animation-loader.json';
import { TextEffect } from '../../motion-primitives/text-effect';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RestaurantOnboardingAiMagicLoadingProps {}

const Container = styled.div`
  ${tw`flex flex-col gap-4 text-center items-center justify-center w-full h-full relative`}
`;

const Heading = styled.h4`
  ${tw`self-stretch text-neutral-700 text-xl font-semibold`}
`;

const SubTextContainer = styled.div`
  ${tw`self-stretch text-center justify-start`}
`;

const SubText = styled.span`
  ${tw`text-neutral-200 text-base font-medium`}
`;

const BoldSubText = styled.span`
  ${tw`text-neutral-200 text-base font-bold`}
`;

const RestaurantOnboardingAiMagicLoading: React.FC<RestaurantOnboardingAiMagicLoadingProps> = () => {
  const { t } = useTranslation('restaurant-onboarding');

  useRestaurantOnboardingDataQuery();

  return (
    <Container>
      <Lottie loop animationData={startIconAnimationData} />

      <Heading>
        <TextEffect per="char" preset="fade">
          {t('wait_just_a_couple_of_seconds')}
        </TextEffect>
      </Heading>
      <SubTextContainer>
        <SubText>
          <TextEffect per="char" preset="fade">
            {t('we_are_searching_info_on_your_venue')}
          </TextEffect>
        </SubText>
        <div tw="flex self-stretch text-center justify-center gap-1">
          <SubText>
            <TextEffect per="char" preset="fade">
              {t('so')}
            </TextEffect>
          </SubText>
          <BoldSubText>
            <TextEffect per="char" preset="fade">
              {t('you_dont_have_to_input_them')}
            </TextEffect>
          </BoldSubText>
        </div>
      </SubTextContainer>
      <Lottie loop animationData={robotAnimationData} />
    </Container>
  );
};

export default RestaurantOnboardingAiMagicLoading;
